export const LOCAL_ACTIVITY_SEARCH = "?scope=local";

/** Notification detours keep their URL filters without replacing the shared dashboard scope.
 * The search marker survives reloads and travels with links to session details.
 */
export const hasLocalActivityScope = (location: { pathname?: string; search?: string }) =>
  (location.pathname ?? "").startsWith("/recordings/") &&
  new URLSearchParams(location.search ?? "").get("scope") === "local";
